import FormFieldAPI from './form_field_api';
import { FormAPI, FormFieldAPIFactory } from 'lecom-api';
import { GridFormActions, GridFormStore } from 'grid_form/reflux/grid_form_store';
import FormActionTypes from '../../../form/constants/form_action_types';
import GridFormAction from '../../../form/models/action/grid_form_action'; // nem ta usando isso
import GridFormDefaultActions from '../../../grid_form/constants/grid_form_default_actions';
import { generateUUID } from 'utils/uuid';

const MathFunctionsColums = ["decimal", "currency", "number"];

let visibleValue = {};

const CanExecuteMathFunction = format => {
	if (MathFunctionsColums.indexOf(format) === -1) {
		console.warn(Realize.i18n.t("grid.mathFuncitons.operatorErrorType"));
		return false;
	}
	return true
}
/**
 * @class GridFormFieldAPI
 * @extends FormFieldAPI
 */
export default class GridFormFieldAPI extends FormFieldAPI {

	/**
	 * @constructor
	 * @param {*} param0
	 */
	constructor({ id, storeId, formId, applyMode, type }) {
		super({ id, storeId, formId, applyMode, isGridField: false, type });

		this._fields = null;
		this._type = type;

		delete this.visible;
		delete this.columns;
		delete this.readOnly;
		delete this.disabled;
		delete this.errors;
		delete this.fieldGroupingId;
		delete this.type;
	}

	type() {
		return this._type;
	}

	columns(columnId) {
		const columns = this.get('columns');

		if (columnId === undefined)
			return columns;

		const currentColumn = columns.filter(column => column.name === columnId);

		if (currentColumn.length) {
			const data = currentColumn[0];

			const gridColumnAPI = {
				name: function (value) {
					if (value === undefined)
						return data.name;
				}.bind(this),
				label: function (value) {
					if (value === undefined)
						return data.label;

					return this.editColumn({ name: data.name, label: value });
				}.bind(this),
				visible: function (value) {
					if (value === undefined)
						return data.visible;

					return this.editColumn({ name: data.name, visible: value });
				}.bind(this),
				format: (value) => {
					return this.editColumn({  name: data.name, ruleRender: value });
				}
			}

			gridColumnAPI["sum"] = () => {
				if (CanExecuteMathFunction(data.format)) {
					return this.dataRows().reduce((before, current) => (
						typeof current[data.name] === 'number' ? before + current[data.name] : before
					), 0);
				}
			};

			gridColumnAPI["min"] = () => {
				if (CanExecuteMathFunction(data.format)) {
					return this.dataRows().map(dataRow => dataRow[data.name]).filter(val => val !== null).sort((val1, val2) => val1 > val2 ? 1 : -1)[0];
				}
			};

			gridColumnAPI["max"] = () => {
				if (CanExecuteMathFunction(data.format)) {
					return this.dataRows().map(dataRow => dataRow[data.name]).filter(val => val !== null).sort((val1, val2) => val1 > val2 ? -1 : 1)[0];
				}
			};

			return gridColumnAPI;
		}
		else
			return undefined;
	}

	visible(value) {
		const nodeGrid = $("#input__" + this.id).parent();		
		
		if (value === undefined)
			return !nodeGrid.hasClass("hide");

		visibleValue[this.id] = value;

		this.fields().forEach(element => {
			element.visible(value);

			if (value === true && this.columns())
				this.columns(element.id).visible(true);
		});

		FormAPI.form(this.formId).apply().then(() => {
			this.set({ visible: value });
		});

		value ? nodeGrid.removeClass('hide') : nodeGrid.addClass('hide');

		const isInEagerMode = this._isInEagerMode();
		const storeEvents = this.storeClass.events;

		return isInEagerMode ? this._buildEventPromise(storeEvents.SET_FIELD_PROPERTIES) : this;
	}

	readOnly(value){
		if (value === undefined)
			return this.get('readOnly');

		this.fields().forEach(element => {
			element.readOnly(value);
		});

		FormAPI.form(this.formId).apply();

		return this.set({ readOnly: value });
	}

	disabled(value){
		if (value === undefined)
			return this.get('disabled');

		this.fields().forEach(element => {
			element.disabled(value);
		});

		FormAPI.form(this.formId).apply();

		return this.set({disabled: value});
	}

	/**
	 *
	 * @param {*} fieldId
	 */
	fields(fieldId) {
		if (!this._fields) {
			this._fields = this._buildFieldsAPIs()
		}
		return fieldId ? this._fields.find(field => field.id === fieldId) : this._fields;
	}

	/**
	 *
	 * @param {*} filter
	 */
	dataRows(filter) {
		const storeItem = GridFormStore.store[this.id];
		const dataRows = storeItem ? storeItem.dataRows : [];

		switch(typeof filter) {
			case 'number':
				return dataRows[filter];
			case 'function':
				return dataRows.filter(filter);
			default:
				return dataRows;
		}
	}

	updatePropsRows(filter, props) {
		if (!props || typeof props !== 'object') {
			console.warn(`Nenhuma propriedade dos dados da grid ${this.id} foi atualizada.`);
			return this;
		}

		const storeItem = GridFormStore.store[this.id];
		const { dataRows, propsRows } = storeItem;
		let dataRowsToUpdate = dataRows || [];

		if (typeof filter === 'number') {
			const dataRowsfiltered = dataRowsToUpdate[filter];
			dataRowsToUpdate = dataRowsfiltered ? [dataRowsfiltered] : [];
		}
		else if (typeof filter === 'function') {
			dataRowsToUpdate = dataRowsToUpdate.filter(filter);
		}

		if (!dataRowsToUpdate.length) {
			console.warn(`Não foi encontrado nenhum dado relacionado ao filtro para a grid ${this.id}. Altere o filtro para poder encontrar dados e atualizar as suas propriedades.`);
			return this;
		}

		const propsRowsToUpdate = dataRowsToUpdate.reduce((acc, cur) => {
			return {
				...acc,
				[cur.id]: acc[cur.id] ? { ...acc[cur.id], ...props } : { ...props }
			}
		}, propsRows);

		return this.set({ propsRows: propsRowsToUpdate });
	}

	/**
	 *
	 * @param {*} dataRow
	 */
	insertDataRow(dataRow) {
		const isInEagerMode = this._isInEagerMode();
		const storeEvents = this.storeClass.events;

		GridFormActions.insertDataRow(this.id, dataRow);
		return isInEagerMode ? this._buildEventPromise(storeEvents.GRID_SUBMIT) : this;
	}

	/**
	 *
	 * @param {*} dataRow
	 */
	updateDataRow(dataRow) {
		const isInEagerMode = this._isInEagerMode();
		const storeEvents = this.storeClass.events;

		GridFormActions.updateDataRow(this.id, dataRow);
		return isInEagerMode ? this._buildEventPromise(storeEvents.GRID_SUBMIT) : this;
	}

	/**
	 *
	 * @param {*} dataRowId
	 */
	removeDataRow(dataRowId) {
		const isInEagerMode = this._isInEagerMode();
		const storeEvents = this.storeClass.events;

		GridFormActions.removeDataRow(this.id, dataRowId);
		return isInEagerMode ? this._buildEventPromise(storeEvents.GRID_DESTROY) : this;
	}

	/**
	 *
	 * @param {*} newColumn
	 */
	addColumn(newColumn, first = false) {
		const columns = this.get('columns');

		if ("visible" in newColumn === false) {
			newColumn["visible"] = true;
		}

		let newColumns;

		if (first)
			newColumns = [newColumn].concat(columns);
		else
			newColumns = columns.concat(newColumn);

		return this.set({ columns: newColumns});
	}

	/**
	 *
	 * @param {*} newColumn
	 */
	editColumn(newColumn) {
		const columns = this.get('columns');
		const columnId = newColumn.name;
		const newColumns = columns.map(column => column.name === columnId ? Object.assign({}, column, newColumn) : column);
		return this.set({ columns: newColumns });
	}

	/**
	 *
	 * @param {*} columnId
	 */
	removeColumn(columnId) {
		const columns = this.get('columns');
		const newColumns = columns.filter(column => column.name !== columnId);
		return this.set({ columns: newColumns });
	}

	/**
	 *
	 * @param {*} newAction
	 */
	addAction(newAction) {
		const actions = this.get('actions');
		return this.set({ actions: [...actions, newAction] });
	}

	/**
	 *
	 * @param {*} actionToEdit
	 */
	editAction(actionToEdit) {
		const actions = this.get('actions');
		const newActions = actions.map(action => action.id === actionToEdit.id ? { ...action, ...actionToEdit } : action);

		return this.set({ actions: newActions });
	}

	/**
	 *
	 * @param {*} actionId
	 */
	removeAction(actionId) {
		const actions = this.get('actions');
		const newActions = actions.filter(action => action.id !== actionId);

		return this.set({ actions: newActions });
	}

	inputsValues() {
		var fields = { };
		var len = this._fields.length;
		while (len--) {
			fields[this._fields[len].id] = this._fields[len].value();
		}
		return fields;
	}

	/**
	 *
	 * @param {*} dataRow
	 */
	submit (dataRow) {
		const isInEagerMode = this._isInEagerMode();
		const storeEvents = this.storeClass.events;
		const fieldsGrid = dataRow || this._buildFieldsGrid();

		GridFormActions.submitDataRow(this.id, fieldsGrid);

		return isInEagerMode ? this._buildEventPromise(storeEvents.GRID_SUBMIT) : this;
	}

	errors(errors) {
		if(errors === undefined)
			return this._getErrors();

		return this._setErrors(errors);
	}

	fieldGroupingId() {
		const formAPI = FormAPI.form(this.formId);
		const fieldsGroupings = formAPI.fieldsGroupings();
		const gridName = this.name();
		const groupGrid = fieldsGroupings.find(group => group.fields.find(field => field.gridFormParent === gridName));
		return groupGrid ? groupGrid.id : null;
	}


	_getErrors() {
		const formAPI = FormAPI.form(this.formId);
		const formErrors = formAPI.errors();

		if(formErrors && typeof formErrors === 'object')
			return formErrors[this.id];

		return [];
	}

	_setErrors(errors) {
		const visible = this.get("visible");
 		const formAPI = FormAPI.form(this.formId);
 		const formErrors = formAPI.errors() || {};

		if (Array.isArray(errors)) {
			if (errors.length)
				formErrors[this.id] = errors;
			else if (formErrors.hasOwnProperty(this.id))
				delete formErrors[this._id];
		}
		else if (errors)
			formErrors[this.id] = [errors];
		else if (formErrors.hasOwnProperty(this.id))
			delete formErrors[this.id];

		formAPI.errors(formErrors).apply().then(() => {
			if (this.id !== undefined && formAPI.grids(this.id) !== undefined && visibleValue !== undefined) {
				if (visibleValue[this.id] !== undefined) {
					formAPI.grids(this.id).visible(visibleValue[this.id]).apply();
				}
			}
		});

		return this.set({ errors: errors });
	}

	get(...properties) {
		const storeItem = GridFormStore.store[this.id];
		return storeItem ? this.getProperties(storeItem, properties) : undefined;
	}

	set(properties) {
		const isInEagerMode = this._isInEagerMode();
		const storeItem = GridFormStore.store[this.id];
		const storeActions = GridFormStore.listenables;
		const storeEvents = this.storeClass.events;

		properties['updateUUID'] = generateUUID();

		for (let key in properties){
			if(storeItem)
				storeItem[key] = properties[key];
		}

		return isInEagerMode ? this._buildEventPromise(storeEvents.SET_FIELD_PROPERTIES) : this;
	}

	apply() {
		const storeActions = GridFormStore.listenables;

		return new Promise((resolve, reject) => {
			storeActions.setState(this.id, resolve);
		});
	}

	/**
	 * @private
	 * @param {*} dataRow
	 */
	_buildFieldsGrid (dataRow) {
		const fields = this.get('fields');
		const fieldObj = {};
		const fieldsMaped = fields.map((field) => {
			fieldObj[field.id] = field.value;
		});
		return fieldObj;
	}

	/**
	 * @private
	 */
	_buildFieldsAPIs() {
		var gridfield = this.storeClass.store[this.formId].fields[this.id];
		var fields = gridfield.fields;
		return fields.map((field) => FormFieldAPIFactory.create(field, {
			gridId: this.id,
			formId: this.formId,
			storeId: this.storeId,
			applyMode: this.applyMode,
			isGridField: true
		}));
	}
}
